module.exports = __webpack_public_path__ + "img/image_part_003.78eed6dc.jpg";